import * as Common from '@/tenant/common';

export class TaskCountQuery extends Common.Query {
  constructor(queryName:string, owned:boolean) {
    super(queryName, null);
    this.owned = owned;
    this.onlyOpen = localStorage['onlyOpen'] == 'true';
  }
  public owned: boolean = false;
  public onlyOpen :boolean = true;  
}